import React from "react";
import { useTranslation } from "react-i18next";
import Icon3D from "./Icon3D";

/**
 * Full-screen modal shown when the API returns 403 LODGE_FROZEN.
 * Triggered by an axios interceptor (see lib/api.js).
 */
export default function FrozenScreen({ open, onClose }) {
  const { t, i18n } = useTranslation();
  if (!open) return null;
  const message =
    open.message_ro && i18n.language !== "en"
      ? open.message_ro
      : open.message_en || t("frozen.message");
  return (
    <div
      className="dialog-overlay"
      style={{ zIndex: 9999, background: "rgba(13,27,42,0.88)" }}
      data-testid="frozen-screen"
    >
      <div
        className="dialog-panel"
        style={{
          maxWidth: 460,
          textAlign: "center",
          padding: "2.5rem 2rem",
          borderTop: "4px solid #c9a84c",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.2rem" }}>
          <Icon3D name="hourglass" size={72} alt="" />
        </div>
        <h2
          style={{
            fontFamily: "Cinzel, serif",
            fontSize: "1.4rem",
            letterSpacing: "0.18em",
            color: "#0d1b2a",
            marginBottom: "0.6rem",
            textTransform: "uppercase",
          }}
        >
          {t("frozen.title")}
        </h2>
        <p
          style={{
            fontFamily: "'Crimson Text', serif",
            fontSize: "1.05rem",
            color: "#34322d",
            lineHeight: 1.55,
            marginBottom: "1.6rem",
          }}
        >
          {message}
        </p>
        <button
          type="button"
          onClick={onClose}
          className="btn-primary-gold"
          data-testid="frozen-screen-ok"
          style={{ minWidth: 160 }}
        >
          {t("frozen.ok")}
        </button>
      </div>
    </div>
  );
}
